import React from 'react';

// Generalized from the inline StatusBadge/LENDER_STATUS_CFG pattern in
// LoanSubscriberDetail.jsx — dot + soft background + text color per status.
const STATUS_CFG = {
  active:        { bg: 'bg-emerald-50', text: 'text-emerald-700', dot: 'bg-emerald-500' },
  approved:      { bg: 'bg-emerald-50', text: 'text-emerald-700', dot: 'bg-emerald-500' },
  success:       { bg: 'bg-emerald-50', text: 'text-emerald-700', dot: 'bg-emerald-500' },
  kyc_done:      { bg: 'bg-cyan-50',    text: 'text-cyan-700',    dot: 'bg-cyan-500'    },
  mandate_done:  { bg: 'bg-cyan-50',    text: 'text-cyan-700',    dot: 'bg-cyan-500'    },
  pre_approved:  { bg: 'bg-blue-50',    text: 'text-blue-700',    dot: 'bg-blue-500'    },
  init:          { bg: 'bg-blue-50',    text: 'text-blue-700',    dot: 'bg-blue-400'    },
  pending:       { bg: 'bg-amber-50',   text: 'text-amber-700',   dot: 'bg-amber-400'   },
  suspended:     { bg: 'bg-orange-50',  text: 'text-orange-700',  dot: 'bg-orange-500'  },
  closed:        { bg: 'bg-gray-100',   text: 'text-gray-600',    dot: 'bg-gray-400'    },
  rejected:      { bg: 'bg-red-50',     text: 'text-red-700',     dot: 'bg-red-500'     },
  failed:        { bg: 'bg-red-50',     text: 'text-red-700',     dot: 'bg-red-500'     },
  repaid:        { bg: 'bg-emerald-50', text: 'text-emerald-700', dot: 'bg-emerald-500' },
  repayment_pending: { bg: 'bg-amber-50', text: 'text-amber-700', dot: 'bg-amber-400'   },
  overdue:       { bg: 'bg-red-100',    text: 'text-red-900',     dot: 'bg-red-700'     },
  reversed:      { bg: 'bg-gray-100',   text: 'text-gray-600',    dot: 'bg-gray-400'    },
  refunded:      { bg: 'bg-cyan-50',    text: 'text-cyan-700',    dot: 'bg-cyan-500'    },
};
const DEFAULT_STATUS_CFG = { bg: 'bg-gray-100', text: 'text-gray-600', dot: 'bg-gray-400' };

const humanize = (str) => {
  if (!str) return '';
  return str.replace(/-/g, ' ').replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
};

const StatusBadge = ({ status, label }) => {
  const key = (status || '').toLowerCase();
  const cfg = STATUS_CFG[key] || (key.startsWith('emandate') ? STATUS_CFG.pending : DEFAULT_STATUS_CFG);
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ring-1 ring-inset ring-black/5 ${cfg.bg} ${cfg.text}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${cfg.dot}`} />
      {label || humanize(status) || '—'}
    </span>
  );
};

export default StatusBadge;
